/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathSumIcon20Solid = forwardRef('MathSumIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.807 5.54C2.364 4.347 3.21 2 5.083 2H15.75a1.25 1.25 0 1 1 0 2.5H6.471l4.784 3.96a2 2 0 0 1 0 3.08L6.471 15.5h9.279a1.25 1.25 0 1 1 0 2.5H5.083c-1.874 0-2.72-2.346-1.276-3.54L9.196 10 3.807 5.54Z" })));
});
